// extracted by mini-css-extract-plugin
module.exports = {"contents":"LayoutWeb_contents__y4xVt","box-nav":"LayoutWeb_box-nav__6AWhU","box-categ":"LayoutWeb_box-categ__1dAm7"};